import React from 'react'
import Tooltip from './Tooltip';


const Icon = ({ name = "info" }) => {
  const icons = {
    info: (
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M7.46647 10.1333V7.46665M7.46647 4.79999H7.47314M14.1331 7.46665C14.1331 11.1486 11.1484 14.1333 7.46647 14.1333C3.78457 14.1333 0.799805 11.1486 0.799805 7.46665C0.799805 3.78476 3.78457 0.799988 7.46647 0.799988C11.1484 0.799988 14.1331 3.78476 14.1331 7.46665Z" stroke="#667085" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    ),
  };
  return icons[name] || icons.info;
};


const SharedScopeTitle = () => {
  return (
    <div className="sharedScopeTitle">
      <span className="SharedScopeTitleText">University Sharing</span>
      <span className="SharedScopeTitleIcon">
        <Tooltip title="Sharing enables universities to access the topic" placement="bottom" isIcon={true} className="infoTooltip">
          <Icon name={"info"} />
        </Tooltip>
      </span>
    </div>
  );
};

export default SharedScopeTitle;